function filterSectors() {
  const searchTerm = document.getElementById('searchInput').value.toLowerCase();
  const sectors = document.querySelectorAll('.card__list');
  let hasVisibleSector = false;
  sectors.forEach((sector) => {
    const sectName = sector.querySelector('.sect-name').innerText.toLowerCase();
    if (sectName.includes(searchTerm)) {
      sector.style.display = '';
      hasVisibleSector = true;
    } else {
      sector.style.display = 'none';
    }
  });
  const noDataMessage = document.querySelector('.no-data-found');
  if (hasVisibleSector) {
    noDataMessage.classList.add('hidden');
  } else {
    noDataMessage.classList.remove('hidden');
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const searchInput = document.getElementById('searchInput');
  searchInput.addEventListener('keyup', filterSectors);
});
